import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import { getApi } from '../services/apiServices';
import { toast } from "react-toastify";

function ActivateEsim() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const [activePlatform, setActivePlatform] = useState('ios');
  const [video, setVideo] = useState(null);
  const [videoLoading, setVideoLoading] = useState(true);

  // Language mapping function to convert app language codes to API language codes
  const getApiLanguageCode = (appLanguage) => {
    const languageMap = {
      'ar': 'ar',     // Arabic
      'da': 'da',     // Danish
      'de': 'de',     // German
      'en': 'en',     // English
      'es': 'es',     // Spanish
      'fr': 'fr',     // French
      'he': 'he',     // Hebrew
      'it': 'it',     // Italian
      'ja': 'ja',     // Japanese
      'ko': 'ko',     // Korean
      'nl': 'nl',     // Dutch
      'no': 'no',     // Norwegian
      'pl': 'pl',     // Polish
      'pt': 'pt',     // Portuguese
      'ru': 'ru',     // Russian
      'sv': 'sv',     // Swedish
      'tr': 'tr',     // Turkish
      'zh': 'zh_CN'   // Chinese (Simplified)
    };
    return languageMap[appLanguage] || 'en'; // Default to English if not found
  };

  const fetchVideo = async (language = currentLanguage) => {
    try {
      setVideoLoading(true);
      const apiLanguage = getApiLanguageCode(language);
      const response = await getApi(`/api/videos?page=esim&lang=${apiLanguage}`);

      if (response?.status && response?.data) {
        // Handle different possible response structures:
        // - response.data could be an array of videos
        // - response.data could be a single video object
        // - response.data.videos could be an array
        let videoData = null;

        if (Array.isArray(response.data)) {
          videoData = response.data[0]; // Take first video if array
        } else if (response.data.videos && Array.isArray(response.data.videos)) {
          videoData = response.data.videos[0]; // Take first video from videos array
        } else if (response.data.video) {
          videoData = response.data; // Single video object
        }

        setVideo(videoData);
      } else {
        setVideo(null);
      }
    } catch (error) {
      console.error('Error fetching video:', error);
      setVideo(null);
    } finally {
      setVideoLoading(false);
    }
  };

  const handlePlatformChange = (platform) => {
    setActivePlatform(platform);
  };

  useEffect(() => {
    fetchVideo();
  }, [currentLanguage]);

  return (
    <>
      <section className="install-top">
        <div className="container">
          <h3>{t('activateEsim.title')}</h3>
          <p>
            {t('activateEsim.description')}
          </p>
          <ul>
            <li
              className={activePlatform === 'ios' ? 'active' : ''}
              onClick={() => handlePlatformChange('ios')}
              style={{ cursor: 'pointer' }}
            >
              <img src={window.getPublicUrl('images/ios.svg')} alt="iOS" />ios
            </li>
            <li
              className={activePlatform === 'android' ? 'active' : ''}
              onClick={() => handlePlatformChange('android')}
              style={{ cursor: 'pointer' }}
            >
              <img src={window.getPublicUrl('images/android.svg')} alt="Android" />Android
            </li>
          </ul>
        </div>
      </section>

      {activePlatform === 'ios' ? (
        <>
          <section className="download-app inst">
            <div className="container">
              <div
                className="download-app-inner need"
                style={{ backgroundImage: `url(${window.getPublicUrl('images/banner-bg.png')})` }}

              >
                <div className="row">
                  <div className="col-sm-6 d-flex align-items-center">
                    <div className="need-left">
                      <h3>{t('activateEsim.requirements.title')}</h3>
                      <ul>
                        <li><img src={window.getPublicUrl('images/check.svg')} alt="Check" />{t('activateEsim.requirements.compatibleIphone')}</li>
                        <li><img src={window.getPublicUrl('images/check.svg')} alt="Check" />{t('activateEsim.requirements.stableWifi')}</li>
                        <li><img src={window.getPublicUrl('images/check.svg')} alt="Check" />{t('activateEsim.requirements.qrCode')}</li>
                        <li><img src={window.getPublicUrl('images/check.svg')} alt="Check" />{t('activateEsim.requirements.mobileApp')}</li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="download-img">
                      <img src={window.getPublicUrl('images/need-img.svg')} alt="Need illustration" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="download-app">
            <div className="container">
              <div className="download-app-inner need activation">
                <div className="row">
                  <div className="col-sm-6 d-flex align-items-center">
                    <div className=''>
                      <div className="need-left">
                        <h3>{t('activateEsim.ios.title')}</h3>
                        <ul>
                          <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.ios.step1')}</li>
                          <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.ios.step2')}</li>
                          <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.ios.step3')}</li>
                          <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.ios.step4')}</li>
                        </ul>
                        <div className="install">
                          <h4>{t('activateEsim.ios.oneTapInstall.title')}</h4>
                          <p>
                            {t('activateEsim.ios.oneTapInstall.description')}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="crousal">
                      <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                        <ol className="carousel-indicators">
                          <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                          {/* <li data-target="#carouselExampleIndicators" data-slide-to="3"></li> */}
                        </ol>
                        <div className="carousel-inner">
                          <div className="carousel-item active">
                            <img className="d-block" src={window.getPublicUrl('images/crousal-img1.png')} alt="First slide" />
                          </div>
                          <div className="carousel-item">
                            <img className="d-block" src={window.getPublicUrl('images/iphone1.png')} alt="Second slide" />
                          </div>
                          <div className="carousel-item">
                            <img className="d-block" src={window.getPublicUrl('images/iphone2.png')} alt="Third slide" />
                          </div>
                          {/* <div className="carousel-item">
                            <img className="d-block" src={window.getPublicUrl('images/iphone3.png')} alt="Third slide" />
                          </div> */}
                        </div>
                        <a
                          className="carousel-control-prev"
                          href="#carouselExampleIndicators"
                          role="button"
                          data-slide="prev"
                        >
                          <img src={window.getPublicUrl('images/pre.svg')} alt="Previous" />
                        </a>
                        <a
                          className="carousel-control-next"
                          href="#carouselExampleIndicators"
                          role="button"
                          data-slide="next"
                        >
                          <img src={window.getPublicUrl('images/next.svg')} alt="Next" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="prefer">
            <div className="container">
              <h3>{t('activateEsim.video.title')}</h3>
              <p>
                {t('activateEsim.video.description')}
              </p>
              <span>
                {videoLoading ? (
                  <div style={{ height: '400px', backgroundColor: '#f0f0f0', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <span className="loader"></span>
                  </div>
                ) : video && video.video ? (
                  <video
                    controls
                    controlsList="nodownload"
                    style={{ width: '100%', height: 'auto', borderRadius: '8px', maxWidth: '100%' }}
                    poster='/images/Frame 1984078866.png'
                    onContextMenu={(e) => e.preventDefault()}
                  >
                    <source src={`https://roam4less.app/backend${video.video}`} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img src={window.getPublicUrl('images/prefer-img.png')} alt="Video Preview" />
                )}
              </span>
            </div>
          </section>

          <section className="download-app inst-bottom">
            <div className="container">
              <div className="download-app-inner">
                <div className="row">
                  <div className="col-sm-5">
                    <div className="download-app-left">
                      <h4>{t('activateEsim.downloadApp.title')}</h4>
                      <h3 dangerouslySetInnerHTML={{ __html: t('activateEsim.downloadApp.subtitle') }}></h3>
                      <p>
                        {t('activateEsim.downloadApp.description')}
                      </p>
                      <ul>
                        <li>
                            <a href="https://apps.apple.com/in/app/roam4less-esim-travel-data/id6756699233" target="_blank" rel="noopener noreferrer">
                                <img src={window.getPublicUrl('images/app-store.png')} alt={t('appDownloadModal.appStore')} />
                            </a>
                        </li>
                        <li>
                            <a href="https://play.google.com/store/apps/details?id=com.roam4less.app&hl=en_IN" target="_blank" rel="noopener noreferrer">
                                <img src={window.getPublicUrl('images/google-play.png')} alt={t('appDownloadModal.googlePlay')} />
                            </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <div className="download-img">
                      <img src={window.getPublicUrl('images/download-app.png')} alt="App Download" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      ) : (
        <>
          <section className="download-app inst">
            <div className="container">
              <div
                className="download-app-inner need"
                style={{ backgroundImage: `url(${window.getPublicUrl('images/banner-bg.png')})` }}

              >
                <div className="row">
                  <div className="col-sm-6 d-flex align-items-center">
                    <div className="need-left">
                      <h3>{t('activateEsim.requirements.title')}</h3>
                      <ul>
                        <li><img src={window.getPublicUrl('images/check.svg')} alt="Check" />{t('activateEsim.requirements.compatibleAndroid')}</li>
                        <li><img src={window.getPublicUrl('images/check.svg')} alt="Check" />{t('activateEsim.requirements.stableWifi')}</li>
                        <li><img src={window.getPublicUrl('images/check.svg')} alt="Check" />{t('activateEsim.requirements.qrCode')}</li>
                        <li><img src={window.getPublicUrl('images/check.svg')} alt="Check" />{t('activateEsim.requirements.mobileApp')}</li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="download-img">
                      <img src={window.getPublicUrl('images/need-img.svg')} alt="Requirements" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="download-app">
            <div className="container">
              <div className="download-app-inner need activation">
                <div className="row">
                  <div className="col-sm-6 d-flex align-items-center">
                    <div className="need-left android">
                      <h3>{t('activateEsim.android.title')}</h3>
                      <ul>
                        <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.android.step1')}</li>
                        <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.android.step2')}</li>
                        <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.android.step3')}</li>
                        <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.android.step4')}</li>
                        <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.android.step5')}</li>
                        <li><span><img src={window.getPublicUrl('images/check.svg')} alt="Check" /></span>{t('activateEsim.android.step6')}</li>
                      </ul>
                      <div className="install">
                        <h4>{t('activateEsim.android.qrNotWorking.title')}</h4>
                        <p>
                          {t('activateEsim.android.qrNotWorking.description')}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="crousal">
                      <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                        <ol className="carousel-indicators">
                          <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                          <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                        </ol>
                        <div className="carousel-inner">
                          <div className="carousel-item active">
                            <img className="d-block" src={window.getPublicUrl('images/anroid1.png')} alt="First slide" />
                          </div>
                          <div className="carousel-item">
                            <img className="d-block" src={window.getPublicUrl('images/anroid2.png')} alt="Second slide" />
                          </div>
                          <div className="carousel-item">
                            <img className="d-block" src={window.getPublicUrl('images/anroid3.png')} alt="Third slide" />
                          </div>
                          <div className="carousel-item">
                            <img className="d-block" src={window.getPublicUrl('images/anroid4.png')} alt="Third slide" />
                          </div>
                        </div>
                        <a
                          className="carousel-control-prev"
                          href="#carouselExampleIndicators"
                          role="button"
                          data-slide="prev"
                        >
                          <img src={window.getPublicUrl('images/pre.svg')} alt="Previous" />
                        </a>
                        <a
                          className="carousel-control-next"
                          href="#carouselExampleIndicators"
                          role="button"
                          data-slide="next"
                        >
                          <img src={window.getPublicUrl('images/next.svg')} alt="Next" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="prefer">
            <div className="container">
              <h3>{t('activateEsim.video.title')}</h3>
              <p>
                {t('activateEsim.video.description')}
              </p>
              <span>
                {videoLoading ? (
                  <div style={{ height: '400px', backgroundColor: '#f0f0f0', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <span className="loader"></span>
                  </div>
                ) : video && video.video ? (
                  <video
                    controls
                    controlsList="nodownload"
                    style={{ width: '100%', height: 'auto', borderRadius: '8px', maxWidth: '100%' }}
                    poster='/images/Frame 1984078866.png'
                    onContextMenu={(e) => e.preventDefault()}
                  >
                    <source src={`https://roam4less.app/backend${video.video}`} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img src={window.getPublicUrl('images/prefer-img.png')} alt="Video Tutorial" />
                )}
              </span>
            </div>
          </section>

          <section className="download-app inst-bottom">
            <div className="container">
              <div className="download-app-inner">
                <div className="row">
                  <div className="col-sm-5">
                    <div className="download-app-left">
                      <h4>{t('activateEsim.downloadApp.title')}</h4>
                      <h3 dangerouslySetInnerHTML={{ __html: t('activateEsim.downloadApp.subtitle') }}></h3>
                      <p>
                        {t('activateEsim.downloadApp.description')}
                      </p>
                       <ul>
                        <li>
                            <a href="https://apps.apple.com/in/app/roam4less-esim-travel-data/id6756699233" target="_blank" rel="noopener noreferrer">
                                <img src={window.getPublicUrl('images/app-store.png')} alt={t('appDownloadModal.appStore')} />
                            </a>
                        </li>
                        <li>
                            <a href="https://play.google.com/store/apps/details?id=com.roam4less.app&hl=en_IN" target="_blank" rel="noopener noreferrer">
                                <img src={window.getPublicUrl('images/google-play.png')} alt={t('appDownloadModal.googlePlay')} />
                            </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <div className="download-img">
                      <img src={window.getPublicUrl('images/android.png')} alt="Android App" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
}

export default ActivateEsim;
